import { Component, input, output } from '@angular/core';
import { StatusSelectComponent, StatusSelectOption } from '@vectronic/ui';

@Component({
  selector: 'table-datatable-status-select',
  templateUrl: './datatable-status-select.component.html',
  styleUrls: ['./datatable-status-select.component.scss'],
  imports: [StatusSelectComponent],
})
export class DatatableStatusSelectComponent {
  value = input<string | number | undefined>(undefined);
  options = input.required<StatusSelectOption[]>();
  editable = input<boolean>(false);
  placeholder = input<string>('Select…');
  emptySymbol = input<string>('—');
  searchable = input<boolean>(false);

  valueChange = output<string | number>();

  protected onSelect(value: string | number): void {
    this.valueChange.emit(value);
  }
}
